import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { useState, forwardRef } from 'react';
import { useTranslation } from 'react-i18next';

import { BREAKPOINTS } from '@/styles/themes/default';
import { IThemeProps } from '@/styles/themes/types';

import { Container } from '../core/Grid';
import { H2 } from '../core/Heading';
import { EventExampleTabContent } from './EventExampleTabContent';
import { TAB_ITEMS } from './eventExampleTabHelper';
import { EventExampleTabs } from './EventExampleTabs';

const TitleContainer = styled.div<IThemeProps>`
  max-width: 794px;
  margin: 0 auto;
  margin-bottom: 40px;

  @media (min-width: ${BREAKPOINTS.Desktop.min}px) {
    margin-bottom: 48px;
  }
`;

const Wrapper = styled.div`
  padding-top: 100px;

  @media (min-width: ${BREAKPOINTS.Tablet.min}px) {
    padding-top: 70px;
  }
`;

export const EventExample = forwardRef<undefined, any>((props, ref) => {
  const { t } = useTranslation();
  const [activeTabIndex, setActiveTabIndex] = useState(null);

  return (
    <Wrapper ref={ref}>
      <Container>
        <TitleContainer>
          <H2
            css={css`
              text-align: center;
              margin-bottom: 56px;
            `}
          >
            {t('landing.eventExampleTitle')}
          </H2>
        </TitleContainer>
        <EventExampleTabs tabItems={TAB_ITEMS} activeTabIndex={activeTabIndex} onChangeTab={setActiveTabIndex} />
        <EventExampleTabContent activeTab={TAB_ITEMS[activeTabIndex]?.labelKey} />
      </Container>
    </Wrapper>
  );
});
